var _defs, _path, _g, _g2, _g3, _g4, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNz({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-nz",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v.5L1 0z",
    transform: "translate(0 -.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-.5L1 0z",
    transform: "rotate(-36 .5 -.2)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(72 0 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(-72 0 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1 1) rotate(72)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    fillRule: "evenodd",
    d: "M0 0h512v512H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-148.7 90.5) scale(.60566)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    fill: "#fff",
    transform: "matrix(45.4 0 0 45.4 900 120)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    fill: "#cc142b",
    transform: "matrix(30 0 0 30 900 120)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82 418.7 105.1) scale(.60566)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    fill: "#fff",
    transform: "rotate(-82 519 -457.7) scale(40.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    fill: "#cc142b",
    transform: "rotate(-82 519 -457.7) scale(25)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82 418.7 105.1) scale(.60566)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    fill: "#fff",
    transform: "rotate(-82 668.6 -327.7) scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    fill: "#cc142b",
    transform: "rotate(-82 668.6 -327.7) scale(30)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-148.7 90.5) scale(.60566)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    fill: "#fff",
    transform: "matrix(50.4 0 0 50.4 900 480)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    fill: "#cc142b",
    transform: "matrix(35 0 0 35 900 480)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h256v256H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M256 0v32l-95 96 95 93.5V256h-33.5L127 162l-93 94H0v-34l93-93.5L0 37V0h31l96 94 93-94z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m92 162 5.5 17L21 256H0v-1.5zm62-6 27 4 75 73.5V256zM256 0l-96 98-2-22 75-76zM0 .5 96.5 95 67 91 0 24.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M88 0v256h80V0zM0 88v80h256V88z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M0 104v48h256v-48zM104 0v256h48V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNz);
export default __webpack_public_path__ + "static/media/nz.d6ab98cf3bedb7cd0e5b87953d814679.svg";
export { ForwardRef as ReactComponent };